module.exports = __webpack_public_path__ + "static/img/award2.ba64fc6.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/index/award2.png
// module id = iTGd
// module chunks = 7